import React, {Component, ReactNode} from 'react';
import {EmptyState} from './EmptyState';

/*
    IMPORT AND APPLY EMPTY STATE WHEN READY
*/

interface Props {
    children: ReactNode;
    onError?: () => void;
}

interface State {
    hasError: boolean;
    error?: Error;
}

export class ChartErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error: Error): State {
        // Update state so the next render will show the fallback UI
        console.error('ChartErrorBoundary caught an error:', error);
        return {hasError: true, error};
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        // You can log the error to an error reporting service here
        console.error('ChartErrorBoundary componentDidCatch:', error, errorInfo);

        // Call the onError callback if provided
        if (this.props.onError) {
            this.props.onError();
        }
    }

    render() {
        if (this.state.hasError) {
            return <EmptyState />;
        }

        return this.props.children;
    }
}
